import { AbortError as AbortPRetryError } from 'p-retry';

export class AbortError extends Error {
    name = 'AbortError';
    constructor(message = 'aborted') {
        super(message);
    }
}

/** NoArgsError - throws when arguments not passed to cli */
export class NoArgsError extends Error {
    name = 'NoArgsError';
}

/** ArgError - throws when argument is invalid */
export class ArgError extends Error {
    name = 'ArgError';
}

export class StopRunOnError extends Error {
    name = 'StopRunOnError';
}

export class GetBrowserError extends Error {
    constructor(err: string | Error, public readonly type?: string) {
        super(err instanceof Error ? err.message : err, { cause: err });
    }
}

export class PageNotAvailableError extends AbortPRetryError {}
export class WebdriverCapabilitiesError extends AbortPRetryError {}

export class InvalidGridCredentials extends AbortPRetryError {}

export class TimeoutError extends Error {}

export class QuotaDepletedError extends Error {}

export class GridError extends Error {
    name = 'GridError';

    toString() {
        return this.message;
    }
}

export class GridConcurrencyError extends GridError {
    name = 'GridConcurrencyError';
}

export class NpmPackageError extends Error {
    name = 'NpmPackageError';
}

export class SeleniumCrashError extends Error {
    message = 'selenium driver crashed';
    name = 'SeleniumCrashError';
}

export class NpmPermissionsError extends Error {
    constructor(public readonly path: string) {
        super(`Testim had missing write access to ${path}`);
    }
}

export class IncompatibleNpmPackageError extends Error {
    constructor(packageName: string) {
        super(`Package for CLI action need to have a CommonJS export which the package ${packageName} does not have`);
    }
}

export class NotImplementedError extends Error {
    constructor(descendant = false) {
        let message = 'not implemented';
        if (descendant) {
            message = 'should be implemented on descendant';
        }
        super(message);
    }
}
